export default "__VITE_ASSET__rEniAGfq__"